import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

interface AIBriefingCardProps {
  summary: string | null;
  isLoading?: boolean;
}

export default function AIBriefingCard({ summary, isLoading = false }: AIBriefingCardProps) {
  return (
    <Card 
      elevation={3} 
      sx={{ 
        mb: 3,
        background: 'linear-gradient(to right, #f5f7fa, #e8edf5)',
        borderLeft: '4px solid',
        borderColor: 'primary.main'
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <BusinessCenterIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
            C-Suite Daily Briefing
          </Typography>
        </Box>
        
        {isLoading ? (
          <>
            <Skeleton animation="wave" height={20} width="90%" />
            <Skeleton animation="wave" height={20} width="95%" />
            <Skeleton animation="wave" height={20} width="80%" />
          </>
        ) : summary ? (
          <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
            {summary}
          </Typography>
        ) : (
          <Typography variant="body1" color="text.secondary">
            No briefing available for today. Check back later.
          </Typography>
        )}
        
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Typography variant="caption" color="text.secondary">
            Generated {new Date().toLocaleDateString()} by CRO Agent
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
} 